const common = {
  siteTitle: 'Hệ thống thu thập dữ liệu',
  notFound: 'Not found',
  confirm: 'Xác nhận',
  cancel: 'Hủy',
  exportExcel: 'Xuất file Excel',
  addNew: 'Thêm mới',
  search: 'Tìm kiếm',
  filter: 'Lọc',
  upload: 'Tải lên',
  url: 'Đường dẫn',
  clickToUpload: 'Nhấn để tải lên',
  dragAndDrop: 'hoặc kéo và thả',
  required: 'SVG, PNG, JPG hoặc JPEG, MP4 (Tối đa 20MB)',
  enterLink: 'Nhập link',
  close: 'Đóng',
  error: 'Xảy ra lỗi',

  //Sidebar
  home: 'Trang chủ',
  logout: 'Đăng xuất',

  // Dashboard
  dashboardGroup: 'Dashboard',
  dashboardHome: 'Trang chủ',
  dashboardDevice: 'Dashboard thiết bị',
  dashboardBody: 'Dashboard thân vỏ',
  dashboardVibration: 'Dashboard CB rung',
  dashboardLaser: 'Bảo trì dự đoán máy Laser',
  dashboardMaintenance: 'Tổng quan bảo trì',
  dashboardIncident: 'Dashboard sự cố',
  dashboardIncidentList: 'Tổng quan lỗi',
  dashboardErrorLogList: 'Log lỗi vận hành',
  dashboardMaterial: 'Dashboard vật tư',
  dashboardFeature: 'Dashboard tính năng',
  dashboardAnalytics: 'Dashboard phân tích',

  // Cấu hình
  configGroup: 'Cấu hình',
  machineTypeManage: 'Loại máy',
  connectionProtocolManage: 'Giao thức kết nối',
  unitManage: 'Đơn vị',
  deviceManage: 'Thiết bị',
  mailConfigManage: 'Cấu hình gửi mail',

  // Hệ thống
  systemManage: 'Hệ thống',
  userManage: 'Người dùng',
  roleManage: 'Vai trò',

  //User
  account: 'Tài khoản',
  name: 'Tên',
  email: 'Email',
  permission: 'Phân quyền',
  userInfo: 'Thông tin tài khoản',
  phoneNumber: 'Số điện thoại',
  mobile: 'Di động',
  changePassword: 'Đổi mật khẩu',
  userProfile: 'Tài khoản',

  breadcrumb: {
    home: 'Home',
    dashboard: 'Thống kê',
    users: 'Danh sách người dùng',
    editUser: 'Sửa người dùng',
    addUser: 'Thêm người dùng',
    notiList: 'Danh sách thông báo'
  }
};

export default common;
